import { Injectable } from '@angular/core';
import { BaseService } from '../../abstracts/base.service';
import { ResultModel } from '../../models/result.model';
import { SurveyParticipantAnswerModel } from '../../models/survey/survey-participant-answer.model';
import { SurveyParticipantPageModel } from '../../models/survey/survey-participant-page.model';
import { SurveyParticipantModel } from '../../models/survey/survey-participant.model';

@Injectable({
  providedIn: 'root'
})
export class SurveyParticipantService extends BaseService  {

  // listAllForSelect() {
  //   return this.httpClient.get<ResultModel<SurveyParticipantModel[]>>(this.getApiUrl('surveyparticipants'));

  // }

  listAll(formData:FormData) {
    return this.httpClient.post<ResultModel<SurveyParticipantModel[]>>(this.getApiUrl('surveyparticipants/list'), formData);
  }

  create(surveyparticipant: SurveyParticipantModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('surveyparticipants'), surveyparticipant);
  }

  update(surveyparticipant: SurveyParticipantModel) {
    return this.httpClient.put(this.getApiUrl('surveyparticipants'), surveyparticipant);
  }

  updateShare(surveyparticipant: SurveyParticipantModel[]) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`surveyparticipants/share`), surveyparticipant);
  }

  get(surveyParticipantID) {
    return this.httpClient.get<{ SurveyParticipant: SurveyParticipantModel, SurveyParticipantPages: SurveyParticipantPageModel[], SurveyParticipantAnswers: SurveyParticipantAnswerModel[] }>(this.getApiUrl('surveyparticipants/' + surveyParticipantID));
  }
  getclass(documnetShareID,classID) {
    return this.httpClient.get<{ SurveyParticipantAnswers: SurveyParticipantAnswerModel[] }>(this.getApiUrl(`surveyparticipants/class-test/${documnetShareID}/${classID}`));
  }

  getTrainingReportTest(documnetShareID,trainingID) {
    return this.httpClient.get<{ SurveyParticipantAnswers: SurveyParticipantAnswerModel[] }>(this.getApiUrl(`surveyparticipants/training-test/${documnetShareID}/${trainingID}`));
  }

  getClassReport(documnetShareID,classID) {
    return this.httpClient.get<{ SurveyAnswer: any[] }>(this.getApiUrl(`surveyparticipants/class/${documnetShareID}/${classID}`));
  }

  getTrainingReport(documnetShareID,trainingID) {
    return this.httpClient.get<{ SurveyAnswer: any[] }>(this.getApiUrl(`surveyparticipants/training/${documnetShareID}/${trainingID}`));
  }

  getClassVakaReport(documnetShareID,classID) {
    return this.httpClient.get<{ SurveyAnswer: any[] }>(this.getApiUrl(`surveyparticipants/class-vaka/${documnetShareID}/${classID}`));
  }

  getTrainingVakaReport(documnetShareID,trainingID) {
    return this.httpClient.get<{ SurveyAnswer: any[] }>(this.getApiUrl(`surveyparticipants/training-vaka/${documnetShareID}/${trainingID}`));
  }

  delete(id:string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl('surveyparticipants/' + id));
  }

}
